import { TILE_LIBRARY_TYPES } from '../../../state/map/tiles/constants';
import LeafletMarker from './LeafletMarker';
import HereMarker from './HereMarker';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [TILE_LIBRARY_TYPES.LEAFLET]: LeafletMarker,
  [TILE_LIBRARY_TYPES.JSLA]: HereMarker,
};
